import React, { FC } from 'react';
import { ORDER_STATUS } from '@baemingo/order-status-events/dist/types';
import { useStorage } from '~Components/Storage';
import SelectList from '~ComponentsImproved/SelectList';
import Heading from '~ComponentsImproved/Typography/Heading';
import { useDispatch, useI18n, useLogger, useSelector } from '~Hooks';
import { Box } from '~Styles';
import * as actions from '~actions';

interface Props {
  isInKDSModal?: boolean;
}

const StationSettings: FC<Props> = ({ isInKDSModal }) => {
  const logger = useLogger('settings-v2');
  const [storage, updateStorage, storageLoading] = useStorage();
  const stations = useSelector((state) => state.stations ?? []);
  const dispatch = useDispatch();
  const [{ autoAcceptAppOrders }] = useStorage();
  const { i18n } = useI18n();

  const update = (stationId: string) => {
    // Still setting station in state becuase old KDS uses it
    dispatch(actions.setStation(stationId));
    updateStorage({ selectedKDSStation: stationId });

    const selected = stations.find((station) => station.id === stationId);

    logger.info('Updating Settings (change station)', {
      fields: { selectedStationId: stationId, selectedStationName: selected?.name },
    });

    dispatch(actions.addToast(i18n('TOAST.Station.Updated'), true));
  };

  if (storageLoading) {
    return null;
  }

  return (
    <Box padding="large">
      {!isInKDSModal && (
        <Heading level={4} bottom={8} color="#fff">
          {i18n('Settings.Station.Choose')}
        </Heading>
      )}
      <SelectList
        list={[
          {
            id: 'NONE',
            name: i18n('Settings.StationNone') + ' ' + i18n('Settings.StationDontAssign'),
          },
          ...stations.map((station) => ({
            id: station.id,
            name: station.name,
          })),
        ]}
        selectedId={storage.selectedKDSStation ?? 'NONE'}
        onSelect={update}
        dark
      />
    </Box>
  );
};

export default StationSettings;
